import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { RegexConstants, RegexValidator } from '../../core/utility/lgv-regex-validator';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LgvClientService, LgvUserService, NotificationService } from '../../core/core.module';
import { catchError, of, Subject, take } from 'rxjs';

@Component({
    selector: 'lgv-new-client-dialog',
    templateUrl: './new-client-dialog.component.html',
    styleUrls: ['./new-client-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewClientDialogComponent implements OnInit, OnDestroy {
    clientForm: UntypedFormGroup;
    onDestroy$ = new Subject();
    constructor(private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<NewClientDialogComponent>,
        private lgvClientSvc: LgvClientService,
        private lgvUserSvc: LgvUserService,
        private notifService: NotificationService
    ) { }

    ngOnInit(): void {
        this.clientForm = this.fb.group({
            firstName: [null, [Validators.required]],
            lastName: [null, [Validators.required]],
            email: [null, [Validators.required, RegexValidator(RegexConstants.EMAIL),]],
            mobilePhone: [null],
        });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(null);
        this.onDestroy$.complete();
    }

    saveClient() {
        const clientModel = {
            ...this.clientForm.value,
            ownerId: this.lgvUserSvc.AgentID
        }
        this.lgvClientSvc.SaveClient(clientModel).pipe(
            take(1),
            catchError((error) => of(error))
        ).subscribe((client) => {
            if(client?.error) {
                this.notifService.error('Failed to add client');
            } else {
                this.notifService.success('Client has been added');
            }
            
            this.dialogRef.close(true);
        });
    }

}
